import { baseURL } from '@/api/request'
import request from '@/api/request'
import Cookies from 'js-cookie'
import qs from 'qs'

/**
 * 获取任务列表
 * @param page
 * @param limit
 */
export const getJobs = (params) => {
  return request({
    url: 'scheduler/job',
    params,
    method: 'get'
  })
}
/**
 * 获取名师信息列表
 * @param page
 * @param limit
 * @param teacherName
 */
export const getListPage = (params) => {
  return request({
    url: 'radioweb/adm/teacher/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 教师姓名模糊搜索
 * @param id
 */
export const getTeacher = (data) => {
  return request({
    url: 'radioweb/adm/teacher/getTeacher',
    data,
    method: 'get'
  })
}
/**
 * 添加名师信息
 * @param recommendState
 * @param sortNum
 * @param teacherAchievement
 * @param teacherIntroduce
 * @param teacherName
 * @param teacherPropagateUrl
 * @param teacherUrl
 */
export const addTeacher = (data) => {
  return request({
    url: 'radioweb/adm/teacher/addTeacher',
    data,
    method: 'post',
    type: 'json'
  })
}
/**
 * 编辑名师
 */
export const updateTeacher = (data) => {
  return request({
    url: 'radioweb/adm/teacher/updateTeacher',
    data,
    method: 'post',
    type: 'json'
  })
}
/**
 * 启用/停用状态
 * @param id
 */
export const updateState = (data) => {
  return request({
    url: 'radioweb/adm/teacher/updateState',
    data,
    method: 'post'
  })
}
/**
 * 是否推荐
 * @param id
 */
export const updateRecommendState = (data) => {
  return request({
    url: 'radioweb/adm/teacher/updateRecommendState',
    data,
    method: 'post'
  })
}
/**
 * 删除名师
 * @param id
 */
export const delTeacher = (data) => {
  return request({
    url: 'radioweb/adm/teacher/delTeacher',
    data,
    method: 'post'
  })
}
/**
 * 合作单位列表
 * @param page
 * @param limit
 */
export const getCooperationList = (params) => {
  return request({
    url: 'radioweb/adm/cooperationUnit/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 获取合作单位
 * @param id
 */
export const getClassifyList = (params) => {
  return request({
    url: 'radioweb/adm/cooperationUnitClassify/getList',
    params,
    method: 'get'
  })
}
/**
 * 停用/启用 分类
 * @param id
 */
export const classifyUpdateState = (data) => {
  return request({
    url: 'radioweb/adm/cooperationUnitClassify/updateState',
    data,
    method: 'post'
  })
}
/**
 * 添加合作单位
 * @param id
 */
export const addCooperationUnit = (data) => {
  return request({
    url: 'radioweb/adm/cooperationUnit/addCooperationUnit',
    data,
    method: 'post',
    type: 'json'
  })
}
/**
 * 编辑合作单位
 * @param id
 */
export const updateCooperationUnit = (data) => {
  return request({
    url: 'radioweb/adm/cooperationUnit/updateCooperationUnit',
    data,
    method: 'post',
    type: 'json'
  })
}
/**
 * 删除合作单位
 * @param id
 */
export const delCooperationUnit = (data) => {
  return request({
    url: 'radioweb/adm/cooperationUnit/delCooperationUnit',
    data,
    method: 'post'
  })
}
/**
 * 启用/停用 合作单位
 * @param id
 */
export const cooperatorUpdateState = (data) => {
  return request({
    url: 'radioweb/adm/cooperationUnit/updateState',
    data,
    method: 'post'
  })
}
/**
 * 机构管理列表
 * @param page
 * @param limit
 */
export const organizationList = (params) => {
  return request({
    url: 'radioweb/adm/organization/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 添加机构管理
 * @param page
 * @param limit
 */
export const addOrganization = (data) => {
  return request({
    url: 'radioweb/adm/organization/addOrganization',
    data,
    method: 'post'
  })
}
/**
 * 编辑机构管理
 * @param page
 * @param limit
 */
export const updateOrganization = (data) => {
  return request({
    url: 'radioweb/adm/organization/updateOrganization',
    data,
    method: 'post'
  })
}
/**
 * 获取机构管理
 */
export const getContent = (params) => {
  return request({
    url: 'radioweb/adm/organizationContent/getContent',
    params,
    method: 'get'
  })
}
/**
 * 删除机构
 * @param id
 */
export const delOrganization = (params) => {
  return request({
    url: 'radioweb/adm/organization/delOrganization',
    params,
    method: 'post'
  })
}
/**
 * 删除机构字段
 * @param id
 */
export const delOrganizationField = (params) => {
  return request({
    url: 'radioweb/adm/organizationField/delOrganizationField',
    params,
    method: 'post'
  })
}
/**
 * 机构状态
 * @param id
 */
export const organizationState = (params) => {
  return request({
    url: 'radioweb/adm/organization/updateStatus',
    params,
    method: 'post'
  })
}
/**
 * 机构字段列表
 * @param page
 * @param limit
 */
export const getFieldList = (params) => {
  return request({
    url: 'radioweb/adm/organizationField/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 机构字段
 */
export const getField = (params) => {
  return request({
    url: 'radioweb/adm/organizationField/getList',
    params,
    method: 'get'
  })
}
/**
 * 新增机构字段
 * @param id
 */
export const addOrganizationField = (params) => {
  return request({
    url: 'radioweb/adm/organizationField/addOrganizationField',
    params,
    method: 'post',
    type: 'json'
  })
}
/**
 * 编辑机构管理字段
 */
export const updateOrganizationField = (params) => {
  return request({
    url: 'radioweb/adm/organizationField/updateOrganizationField',
    params,
    method: 'post',
    type: 'json'
  })
}
/**
 * 机构字段排序号
 * @param id
 * @param sortNum
 */
export const updateSortNum = (params) => {
  return request({
    url: 'radioweb/adm/organizationField/updateSortNum',
    params,
    method: 'post'
  })
}
/**
 * 机构字段状态
 * @param id
 * @param status
 */
export const fieldStatus = (params) => {
  return request({
    url: 'radioweb/adm/organizationField/updateStatus',
    params,
    method: 'post'
  })
}
/**
 * 证书列表
 * @param page
 * @param limit
 */
export const getCertificate = (params) => {
  return request({
    url: 'radioweb/adm/certificateInfo/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 证书状态
 */
export const updateCertificateInfo = (data) => {
  return request({
    url: 'radioweb/adm/certificateInfo/updateCertificateInfo',
    data,
    method: 'post'
  })
}
/**
 * 考试安排列表
 * @param page
 * @param limit
 */
export const getExamList = (params) => {
  return request({
    url: 'radioweb/adm/examPlan/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 添加考试安排
 */
export const addExamPlan = (data) => {
  return request({
    url: 'radioweb/adm/examPlan/addExamPlan',
    data,
    method: 'post',
    type: 'json'
  })
}
/**
 * 编辑考试安排
 */
export const updateExamPlan = (data) => {
  return request({
    url: 'radioweb/adm/examPlan/updateExamPlan',
    data,
    method: 'post',
    type: 'json'
  })
}
/**
 * 是否推荐考试安排
 * @param id
 */
export const updateExamRecommend = (params) => {
  return request({
    url: 'radioweb/adm/examPlan/updateRecommendState',
    params,
    method: 'post'
  })
}
/**
 * 考试安排 启用/停用
 * @param id
 */
export const updateExamState = (params) => {
  return request({
    url: 'radioweb/adm/examPlan/updateState',
    params,
    method: 'post'
  })
}
/**
 * 删除考试安排
 * @param id
 */
export const delExamPlan = (params) => {
  return request({
    url: 'radioweb/adm/examPlan/delExamPlan',
    params,
    method: 'post'
  })
}
/**
 * 人才服务列表
 * @param page
 * @param limit
 */
export const getTalentList = (params) => {
  return request({
    url: 'radioweb/adm/talentServe/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 获取人才服务信息
 * @param id
 */
export const getTalentServe = (params) => {
  return request({
    url: 'radioweb/adm/talentServe/getTalentServe',
    params,
    method: 'get'
  })
}
/**
 * 编辑人才服务
 */
export const updateTalentServe = (data) => {
  return request({
    url: 'radioweb/adm/talentServe/updateTalentServe',
    data,
    method: 'post',
    type: 'json'
  })
}
/**
 * 关于我们列表
 * @param page
 * @param limit
 */
export const getAboutList = (params) => {
  return request({
    url: 'radioweb/adm/aboutUs/getListPage',
    params,
    method: 'get'
  })
}
/**
 * 编辑关于我们
 */
export const updateAboutUs = (data) => {
  return request({
    url: 'radioweb/adm/aboutUs/updateAboutUs',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 内训列表
 */
export const getInternalTrainingList = (params) => {
  return request({
    url: 'radioweb/adm/train/getListPage',
    params,
    method: 'get',
  })
}
/**
 * 新增内训
 */
export const addTrain = (data) => {
  return request({
    url: 'radioweb/adm/train/addTrain',
    data,
    method: 'post',
  })
}
/**
 * 更新内训
 */
export const updateTrain = (data) => {
  return request({
    url: 'radioweb/adm/train/updateTrain',
    data,
    method: 'post',
  })
}
/**
 * 删除内训
 */
export const deleteTrain = (data) => {
  return request({
    url: 'radioweb/adm/train/delTrain',
    data,
    method: 'post',
  })
}
/**
 * 启用/停用 内训
 * @param id
 */
export const trainUpdateState = (data) => {
  return request({
    url: 'radioweb/adm/train/updateStatus',
    data,
    method: 'post'
  })
}
/**
 * 面授班级分类列表
 */
export const getFaceClassList = (params) => {
  return request({
    url: 'radioweb/adm/faceClass/getListPage',
    params,
    method: 'get',
  })
}
/**
 * 更新面授班级
 */
export const updateFaceClassStatus = (data) => {
  return request({
    url: 'radioweb/adm/faceClass/updateStatus',
    data,
    method: 'post',
  })
}
/**
 * 编辑面授班级
 */
export const updateFaceClassData = (data) => {
  return request({
    url: 'radioweb/adm/faceClass/updateFaceClass',
    data,
    method: 'post',
  })
}
/**
 * 新增面授班级
 */
export const addFaceClassData = (data) => {
  return request({
    url: 'radioweb/adm/faceClass/addFaceClass',
    data,
    method: 'post',
  })
}






/**
* 面授班级分类列表
*/
export const getClassInfoList = (params) => {
  return request({
    url: 'radioweb/adm/classInfo/getListPage',
    params,
    method: 'get',
  })
}
/**
* 面授班级分类列表-》发布状态
*/
export const setClassInfoStatus = (params) => {
  return request({
    url: 'radioweb/adm/classInfo/updateStatus',
    params,
    method: 'post',
  })
}
/**
* 面授班级分类列表-》新建班级
*/
export const addClassInfo = (params) => {
  return request({
    url: 'radioweb/adm/classInfo/addClassInfo',
    params,
    method: 'post',
    type: 'json'
  })
}
/**
* 面授班级分类列表-》更新班级
*/
export const updateClassInfo = (data) => {
  return request({
    url: 'radioweb/adm/classInfo/updateClassInfo',
    data,
    method: 'post',
  })
}
/**
* 面授班级分类列表-》培训班分类下拉框
*/
export const getClassInfoSelectList = (params) => {
  return request({
    url: 'radioweb/adm/faceClass/getList',
    params,
    method: 'get',
  })
}
/**
* 面授班级分类列表-》日程管理列表
*/
export const getClassScheduleList = (params) => {
  return request({
    url: 'radioweb/adm/classSchedule/getListPage',
    params,
    method: 'get',
  })
}
/**
* 面授班级分类列表-》添加日程管理
*/
export const addClassSchedule = (params) => {
  return request({
    url: 'radioweb/adm/classSchedule/addClassSchedule',
    params,
    method: 'post',
  })
}

/**
* 面授班级分类列表-》修改日程管理
*/
export const updateClassSchedule = (params) => {
  return request({
    url: 'radioweb/adm/classSchedule/updateClassSchedule',
    params,
    method: 'post',
    type: 'json'
  })
}
/**
* 面授班级分类列表-》删除日程管理
*/
export const delClassSchedule = (params) => {
  return request({
    url: 'radioweb/adm/classSchedule/delClassSchedule',
    params,
    method: 'post',
    type: 'json'
  })
}
/**
* 面授班级分类列表-》配置结业证书
*/
export const addGraduation = (data) => {
  return request({
    url: 'radioweb/adm/classInfo/addGraduation',
    data,
    method: 'post',
  })
}
/**
* 面授班级分类列表-》配置合格证书
*/
export const addQuality = (params) => {
  return request({
    url: 'radioweb/adm/classInfo/addQuality',
    params,
    method: 'post',
    type: 'json'
  })
}
/**
* 面授班级分类列表-》班级列表
*/
export const getClassStudentList = (params) => {
  return request({
    url: 'radioweb/adm/classStudent/getListPage',
    params,
    method: 'get',
    type: 'json'
  })
}
/**
* 面授班级分类列表-》获取证书
*/
export const getCertificateInfo = (params) => {
  return request({
    url: 'radioweb/adm/certificateInfo/getList',
    params,
    method: 'get',
    type: 'json'
  })
}
/**
* 面授班级分类列表-》导入报名表
*/
export const importSignUp = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/importSignUp',
    data,
    method: 'post',
    upload: true
  })
}
/**
* 面授班级分类列表-》导入报名表
*/
export const importCertificate = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/importCertificate',
    data,
    method: 'post',
    upload: true
  })
}
/**
* 面授班级分类列表-》下载报名模版
*/
export const exportSignUp = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/exportSignUp',
    data,
    method: 'get',
    responseType: "blob"
  })
}

/**
* 面授班级分类列表-》查看导入异常日志
*/
export const getExceptionList = (params) => {
  return request({
    url: 'radioweb/adm/importException/getListPage',
    params,
    method: 'get',
  })
}
/**
* 面授班级分类列表-》删除异常日志
*/
export const deleteExceptionList = (params) => {
  return request({
    url: 'radioweb/adm/importException/delImportException',
    params,
    method: 'post',
  })
}

/**
* 面授班级分类列表-》删除全部结业证
*/
export const delAllGraduation = (params) => {
  return request({
    url: 'radioweb/adm/classStudent/delAllGraduation',
    params,
    method: 'get',
  })
}
/**
* 面授班级分类列表-》删除全部合格证
*/
export const delAllCertificate = (params) => {
  return request({
    url: 'radioweb/adm/classStudent/delAllCertificate',
    params,
    method: 'get',
  })
}

/**
* 面授班级分类列表-》单独颁发合格证
*/
export const awardOneCertificate = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/awardOneCertificate',
    data,
    method: 'post',
  })
}
/**
* 面授班级分类列表-》删除合格证
*/
export const delCertificate = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/delCertificate',
    data,
    method: 'post',
  })
}

/**
* 面授班级分类列表-》批量颁发合格证
*/
export const awardCertificate = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/awardCertificate',
    data,
    method: 'post',
  })
}

/**
* 面授班级分类列表-》全部颁发合格证
*/
export const awardAllCertificate = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/awardAllCertificate',
    method: 'post',
    data
  })
}

/**
 * 机构屏蔽词
 */
export const getWordList = () => {
  return request({
    url: '/radioweb/adm/blockWord/getListPage',
    method: 'get',
    params: {
      page: 1,
      limit: 1000
    }
  })
}
/**
 * 添加屏蔽词
 */
export const addWord = (data) => {
  return request({
    url: '/radioweb/adm/blockWord/addBlockWord',
    method: 'post',
    data
  })
}
/**
 * 删除屏蔽词
 */
export const delWord = (data) => {
  return request({
    url: '/radioweb/adm/blockWord/delBlockWord',
    method: 'post',
    data
  })
}
/**
 * 关于我们启用/停用
 */
export const updateAboutUsType = (data) => {
  return request({
    url: '/radioweb/adm/aboutUs/updateAboutUsType',
    method: 'post',
    data
  })
}
/**
 * 关于我们添加
 */
export const addAboutUs = (data) => {
  return request({
    url: '/radioweb/adm/aboutUs/addAboutUs',
    method: 'post',
    data
  })
}
/**
 * 关于我们删除
 */
export const delAboutUs = (data) => {
  return request({
    url: '/radioweb/adm/aboutUs/delAboutUs',
    method: 'post',
    data
  })
}
/**
 * 人才服务启用/停用
 */
export const updateTalentServeType = (data) => {
  return request({
    url: '/radioweb/adm/talentServe/updateTalentServeType',
    method: 'post',
    data
  })
}
/**
 * 人才服务添加
 */
export const addTalentServe = (data) => {
  return request({
    url: '/radioweb/adm/talentServe/addTalentServe',
    method: 'post',
    type: 'json',
    data
  })
}
/**
 * 人才服务删除
 */
export const delTalentServe = (data) => {
  return request({
    url: '/radioweb/adm/talentServe/delTalentServe',
    method: 'post',
    data
  })
}
/**
 * 批量删除学员
 */
export const removeStudent = (data) => {
  return request({
    url: '/radioweb/adm/classStudent/removeStudent',
    method: 'post',
    data
  })
}

/**
 * 职业矩阵列表
 * @param page
 * @param limit
 */
export const getCareerMatrixList = (params) => {
  return request({
    url: 'radioweb/adm/jobMatrix/getListPage',
    method: 'get',
    params
  })
}

/**
 * 获取职业矩阵
 * @param id
 */
export const getCareerMatrix = (params) => {
  return request({
    url: 'radioweb/adm/jobMatrix/getJobMatrix',
    method: 'get',
    params
  })
}

/**
 * 更新职业矩阵
 */
export const updateCareerMatrix = (data) => {
  return request({
    url: 'radioweb/adm/jobMatrix/updateJobMatrix',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 添加职业矩阵
 */
export const addCareerMatrix = (data) => {
  return request({
    url: '/radioweb/adm/jobMatrix/addJobMatrix',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 删除职业矩阵
 */
export const delCareerMatrix = (data) => {
  return request({
    url: '/radioweb/adm/jobMatrix/delJobMatrix',
    method: 'post',
    data
  })
}

/**
 * 启用/停用职业矩阵
 */
export const updateCareerMatrixStatus = (params) => {
  return request({
    url: '/radioweb/adm/jobMatrix/updateStatus',
    method: 'get',
    params
  })
}

//  获取用户信息
export const getPhoneById = params => {
  return request({
    url: '/radioweb/adm/classStudent/getPhoneById',
    method: 'get',
    params
  })
}

/**
 * 获取相关政策及材料附件
 */
export const getTalentServeFileList = (data) => {
  return request({
    url: '/radioweb/adm/talentServe/getTalentServeFileList',
    method: 'post',
    type: 'json',
    data
  })
}

/**
 * 获取相关政策及材料 置顶
 */
export const talentupdateTopFlag = (data) => {
  return request({
    url: '/radioweb/adm/talentServe/updateTopFlag',
    method: 'post',
    type: 'json',
    data
  })
}

// 导出
export function downloadData (url, params, title = '') {
  const filePath = baseURL + url + '?' + qs.stringify(params)
  const token = Cookies.get('tvToken') || Cookies.get('token')
  const xhr = new XMLHttpRequest()
  const formData = new FormData()
  xhr.open('GET', filePath, true)
  xhr.setRequestHeader('Authorization', 'Bearer ' + token)
  xhr.responseType = 'blob'
  xhr.onload = function (e) {
    if (this.status === 200) {
      const blob = this.response

      const filename = title + new Date().getTime() + '.xlsx'
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename)
      } else {
        const a = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      }
    }
  }
  xhr.send(formData)
}
